export default "__VITE_ASSET__3d74df85__"